// @flow
import { Record, Map, List } from "immutable"

import type {
  AlternativeFlightsStateType,
  AlternativeFlightsStateInst,
  Action,
  SearchId,
  Flights,
} from "./AlternativeFlightsDuck.types"

const FETCH = "alternativeFlights/FETCH"
const FETCH_REQUEST = "alternativeFlights/FETCH_REQUEST"
const FETCH_SUCCESS = "alternativeFlights/FETCH_SUCCESS"
const FETCH_FAILURE = "alternativeFlights/FETCH_FAILURE"
const CLEAR = "alternativeFlights/CLEAR"

const AlternativeFlightsState: AlternativeFlightsStateType = Record({
  flights: Map(),
  loading: Map(),
  error: null,
})

export default function(
  state: ?AlternativeFlightsStateInst = new AlternativeFlightsState(),
  action: Action,
) {
  if (!(state instanceof AlternativeFlightsState)) return new AlternativeFlightsState(state)

  switch (action.type) {
    case CLEAR:
      return new AlternativeFlightsState()

    case FETCH_REQUEST:
      return state.setIn(["loading", action.id], true).set("error", false)

    case FETCH_SUCCESS:
      return state
        .setIn(["flights", action.id], List(action.res))
        .setIn(["loading", action.id], false)
        .set("error", false)

    case FETCH_FAILURE:
      return state.setIn(["loading", action.id], false).set("error", action.error)

    default:
      return state
  }
}

export function findAlternatives(id: SearchId, promise: Promise<Flights>) {
  return {
    type: FETCH,
    id,
    promise,
  }
}

export function clearAlternatives() {
  return {
    type: CLEAR,
  }
}
